import React, { useState } from "react";
import COLORS from "../../constants/colors"; // adjust the path as needed
import { notifySuccess, notifyError } from "../../utils/ToastifyProvider";

const Registration = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    gender: "",
    password: "",
    confirmPassword: "",
    companyName: "",
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      notifyError("Passwords do not match.");
      return;
    }

    // You can integrate your API call here
    // console.log("Form Data:", formData);
    notifySuccess("User registered successfully!");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4 py-10">
      <form
        onSubmit={handleSubmit}
        className={`w-full max-w-2xl bg-gray-50 border ${COLORS.borderDefault} rounded-lg shadow p-8`}
      >
        <h2
          className={`text-3xl font-bold text-center mb-6 ${COLORS.textBlack}`}
        >
          Add User
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* First Name */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              <span className="text-red-500">*</span> First Name
            </label>
            <input
              type="text"
              placeholder="Enter First Name"
              value={formData.firstName}
              onChange={(e) => handleChange("firstName", e.target.value)}
              required
              className={`w-full border ${COLORS.borderDefault} rounded-md py-2 px-4 focus:outline-none focus:border-[${COLORS.primary}]`}
            />
          </div>

          {/* Last Name */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              <span className="text-red-500">*</span> Last Name
            </label>
            <input
              type="text"
              placeholder="Enter Last Name"
              value={formData.lastName}
              onChange={(e) => handleChange("lastName", e.target.value)}
              required
              className={`w-full border ${COLORS.borderDefault} rounded-md py-2 px-4 focus:outline-none focus:border-[${COLORS.primary}]`}
            />
          </div>

          {/* Phone */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              <span className="text-red-500">*</span> Phone
            </label>
            <input
              type="tel"
              placeholder="Enter Phone"
              value={formData.phone}
              onChange={(e) => handleChange("phone", e.target.value)}
              required
              className={`w-full border ${COLORS.borderDefault} rounded-md py-2 px-4 focus:outline-none focus:border-[${COLORS.primary}]`}
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              <span className="text-red-500">*</span> Email
            </label>
            <input
              type="email"
              placeholder="Enter Email"
              value={formData.email}
              onChange={(e) => handleChange("email", e.target.value)}
              required
              className={`w-full border ${COLORS.borderDefault} rounded-md py-2 px-4 focus:outline-none focus:border-[${COLORS.primary}]`}
            />
          </div>

          {/* Gender */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              <span className="text-red-500">*</span> Gender
            </label>
            <select
              value={formData.gender}
              onChange={(e) => handleChange("gender", e.target.value)}
              required
              className={`w-full border ${COLORS.borderDefault} rounded-md py-2 px-4 bg-white focus:outline-none focus:border-[${COLORS.primary}]`}
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>

          {/* Company Name */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              Company Name
            </label>
            <input
              type="text"
              placeholder="Enter Company Name"
              value={formData.companyName}
              onChange={(e) => handleChange("companyName", e.target.value)}
              className={`w-full border ${COLORS.borderDefault} rounded-md py-2 px-4 focus:outline-none focus:border-[${COLORS.primary}]`}
            />
          </div>

          {/* Password */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              <span className="text-red-500">*</span> Password
            </label>
            <input
              type="password"
              placeholder="Enter Password"
              value={formData.password}
              onChange={(e) => handleChange("password", e.target.value)}
              required
              className={`w-full border ${COLORS.borderDefault} rounded-md py-2 px-4 focus:outline-none focus:border-[${COLORS.primary}]`}
            />
          </div>

          {/* Confirm Password */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              <span className="text-red-500">*</span> Confirm Password
            </label>
            <input
              type="password"
              placeholder="Confirm Password"
              value={formData.confirmPassword}
              onChange={(e) => handleChange("confirmPassword", e.target.value)}
              required
              className={`w-full border ${COLORS.borderDefault} rounded-md py-2 px-4 focus:outline-none focus:border-[${COLORS.primary}]`}
            />
          </div>
        </div>

        <div className="flex justify-end gap-4 mt-8">
          <button
            type="submit"
            className={`bg-[${COLORS.primary}] ${COLORS.textWhite} rounded-full px-6 py-2 font-medium hover:opacity-90 transition`}
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default Registration;
